import React from 'react';
import styled from 'styled-components';
import useRiveTriggers from '../hooks/useRiveTriggers';


const RiveRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

const RiveCard = styled.div`
  height: 200px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  background: transparent;
`;
const Title = styled.div`
  font-size: 52px;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 32px;
  }
`;

const Desc = styled.div`
  font-size: 18px;
  text-align: center;
  font-weight: 600;
  color: ${({ theme }) => theme.text_secondary};
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;
export default function RiveWidgets({ControlPanelProp, LightDarkModeProp} = {}) {
  const hook = useRiveTriggers();

  const ControlPanel = ControlPanelProp ?? hook.ControlPanel;
  const LightDarkMode = LightDarkModeProp ?? hook.LightDarkMode;

  return (
    <RiveRow>
    <Title>Background Controls</Title>
       <Desc
          style={{
            marginBottom: "40px",
          }}
        >
          Made in Rive, tied to page state in react.
        </Desc>
      <RiveCard>
        <ControlPanel />
      </RiveCard>
      <RiveCard style={{height: '100px'}}>
        <LightDarkMode />
      </RiveCard>
    </RiveRow>
  );
}
